import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { FieldType } from 'features/dynamicForm/types';

export function useAutofill(field) {
    const { watch, setValue } = useFormContext();
    const refValue = watch(field.autofill?.refKey);
    const isRendered = useRef(false);

    useEffect(() => {
        if (isRendered.current && field.autofill) {
            let autofillValue;

            if (field.autofill.valuePath && typeof refValue === 'object' && !Array.isArray(refValue) && refValue !== null) {
                autofillValue = getDeepValue(refValue, field.autofill.valuePath);
                if (field.autofill.mappings) {
                    autofillValue = field.autofill.mappings[autofillValue];
                }
            } else if (field.autofill.mappings) {
                autofillValue = field.autofill.mappings[refValue];
            }

            if (field.type === FieldType.DATE_TIME_FIELD && autofillValue) {
                autofillValue = new Date(autofillValue);
            }

            setValue(field.key, autofillValue, { shouldValidate: true });
        }

        isRendered.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refValue, field]);
}

function getDeepValue(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? undefined;
}
